<div >

  <div class="header accent" style="display: flex; align-items: center; justify-content: center; height: 100px;">
      <div class="h1">In Process</div>
  </div>

  <div class="grid grid-cols-3 h-full w-full content-between place-items-center">
    <uni-nav-card [navItem]="NavigationItems.JobOrdersInProcess"/>
    <uni-nav-card [navItem]="NavigationItems.AddonBins"/>
    <uni-nav-card [navItem]="NavigationItems.ShipPrep"/>
    <uni-nav-card [navItem]="NavigationItems.Vouchers"/>
    <uni-nav-card [navItem]="NavigationItems.ShippingInvoicing"/>
    <uni-nav-card [navItem]="NavigationItems.GoBack" [onClick]="goBack.bind(this)"/>
  </div>



  </div>
